import { useSelector } from "react-redux";

import { Button, Dropdown, Form, Input, Menu } from "antd";

const HotKeywordComponent = ({
	idx,
	keywordList,
	setKeywordList,
	categoryList,
	setCategoryList,
}) => {
	const user = useSelector((state) => state.auth.user);
	const isLoading = useSelector((state) => state.common.loading);
	const mainTitle =
		user?.id === 9 || user?.partners_id === 9
			? ["고민별"]
			: ["성분별", "고민별", "조합별"];
	const keywordTitle = ["검색어명", "대카테고리", "중카테고리"];

	/**
	 * 검색어 핸들링
	 * @param e
	 * @param type
	 */
	const handleKeyword = (e, type) => {
		let list = [...keywordList];
		if (type === "display_word") {
			let { value } = e.target;
			list[idx] = {
				...list[idx],
				display_word: value,
			};
		} else if (type === "main_category") {
			let key = e.key;
			list[idx] = {
				...list[idx],
				main_category: Number(key),
				sub_category: null,
				type: null,
				category_name: null,
				category_id: null,
			};
			let newCategory = [...categoryList];
			newCategory[idx] = [];
			setCategoryList(newCategory);
		} else if (type === "sub_category") {
			let key = e.key;
			list[idx] = {
				...list[idx],
				sub_category: Number(key),
				type: categoryList[0]?.type,
				category_name: categoryList[idx].filter(
					(item) => String(item.id) === key
				)?.[0]?.category_name,
				category_id: categoryList[idx].filter(
					(item) => String(item.id) === key
				)?.[0]?.category_id,
			};
		}
		setKeywordList(list);
	};

	const dropdownCategory = (
		<Menu>
			{mainTitle?.map((title, idx) => (
				<Menu.Item
					onClick={(e) => handleKeyword(e, "main_category")}
					id={"main_category"}
					key={`${idx}`}
				>
					{title}
				</Menu.Item>
			))}
		</Menu>
	);

	const dropdownProduct = (
		<Menu>
			{categoryList[idx]?.map((item) => (
				<Menu.Item
					key={`${item.id}`}
					onClick={(e) => handleKeyword(e, "sub_category")}
				>
					{item.category_name}
				</Menu.Item>
			))}
		</Menu>
	);

	return (
		<>
			<p>{idx + 1}위</p>
			<Form className={`hot-keyword-form`}>
				{keywordTitle?.map((label, index) => (
					<Form.Item
						label={label}
						colon={false}
						style={{
							width: "100%",
							margin: 0,
						}}
						labelAlign="left"
						labelCol={{ span: 8 }}
						wrapperCol={{ span: 16 }}
						className={`hot-keyword-form-item`}
						fieldKey={`keyword-form-item-${index}`}
					>
						{index === 0 ? (
							<Input
								type={`text`}
								placeholder={`ex) 피로영양제, 40대여성, 당뇨영양제`}
								value={
									keywordList[idx]?.display_word
										? keywordList[idx]?.display_word
										: ""
								}
								onChange={(e) => handleKeyword(e, "display_word")}
								id={`display_word`}
								disabled={isLoading}
							/>
						) : index === 1 ? (
							<Dropdown
								overlay={dropdownCategory}
								trigger={["click"]}
								overlayStyle={{
									maxHeight: "20em",
									border: "solid 1px #ced4da",
									overflow: "auto",
								}}
							>
								<Button
									style={{
										display: "flex",
										alignItems: "center",
										gap: "3px",
										padding: "4px 11px",
										width: "100%",
										justifyContent: "space-between",
										overflow: "hidden",
									}}
									loading={isLoading}
								>
									{keywordList[idx]?.main_category !== null
										? mainTitle[keywordList[idx]?.main_category]
										: "카테고리를 선택해주세요"}
									<img
										src={`/assets/images/report/report-search-date-icon-down.png`}
										alt={`드롭다운`}
										style={{
											height: "auto",
											width: "0.8em",
										}}
									/>
								</Button>
							</Dropdown>
						) : (
							<Dropdown
								overlay={dropdownProduct}
								trigger={["click"]}
								overlayStyle={{
									maxHeight: "20em",
									border: "solid 1px #ced4da",
									overflow: "auto",
								}}
							>
								<Button
									style={{
										display: "flex",
										alignItems: "center",
										gap: "3px",
										padding: "4px 11px",
										width: "100%",
										justifyContent: "space-between",
										overflow: "hidden",
									}}
									loading={isLoading}
								>
									{keywordList[idx]?.category_name
										? keywordList[idx]?.category_name
										: "카테고리를 선택해주세요"}
									<img
										src={`/assets/images/report/report-search-date-icon-down.png`}
										alt={`드롭다운`}
										style={{
											height: "auto",
											width: "0.8em",
										}}
									/>
								</Button>
							</Dropdown>
						)}
					</Form.Item>
				))}
			</Form>
		</>
	);
};
export default HotKeywordComponent;
